import { PlaneMap } from '~/modules/sites';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

export default dashboardWrapper(PlaneMap, t('menu.dashboard.settingsSites'));
